/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface SectionSummaryEntity
 */
export interface SectionSummaryEntity {
    /**
     * 
     * @type {number}
     * @memberof SectionSummaryEntity
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SectionSummaryEntity
     */
    scorecardTemplateId?: number;
    /**
     * 
     * @type {string}
     * @memberof SectionSummaryEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SectionSummaryEntity
     */
    scriptContent?: string;
    /**
     * 
     * @type {number}
     * @memberof SectionSummaryEntity
     */
    order?: number;
    /**
     * 
     * @type {Date}
     * @memberof SectionSummaryEntity
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SectionSummaryEntity
     */
    dateUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof SectionSummaryEntity
     */
    isDraft?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SectionSummaryEntity
     */
    rulesCount?: number;
}

/**
 * Check if a given object implements the SectionSummaryEntity interface.
 */
export function instanceOfSectionSummaryEntity(value: object): boolean {
    return true;
}

export function SectionSummaryEntityFromJSON(json: any): SectionSummaryEntity {
    return SectionSummaryEntityFromJSONTyped(json, false);
}

export function SectionSummaryEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionSummaryEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'scorecardTemplateId': json['scorecardTemplateId'] == null ? undefined : json['scorecardTemplateId'],
        'name': json['name'] == null ? undefined : json['name'],
        'scriptContent': json['scriptContent'] == null ? undefined : json['scriptContent'],
        'order': json['order'] == null ? undefined : json['order'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'dateUpdated': json['dateUpdated'] == null ? undefined : (new Date(json['dateUpdated'])),
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
        'rulesCount': json['rulesCount'] == null ? undefined : json['rulesCount'],
    };
}

export function SectionSummaryEntityToJSON(value?: SectionSummaryEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scorecardTemplateId': value['scorecardTemplateId'],
        'name': value['name'],
        'scriptContent': value['scriptContent'],
        'order': value['order'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'dateUpdated': value['dateUpdated'] == null ? undefined : ((value['dateUpdated']).toISOString()),
        'isDraft': value['isDraft'],
        'rulesCount': value['rulesCount'],
    };
}

